<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('sidebar.shortTitle')"
      title="ShowUp & Play"
    >
      <template slot-scope="props" slot="links">
        <!-- <sidebar-item
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/dashboard'
          }"
        >
        </sidebar-item> -->
        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Organizers',
            icon: 'fas fa-users',
            path: '/organizers',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Events', icon: 'fas fa-futbol', path: '/events' }"
        >
        </sidebar-item>
        <!-- <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Passes', icon: 'fas fa-ticket-alt', path: '/passes' }"
        >
        </sidebar-item> -->

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Credits Bundles', icon: 'fas fa-money-bill-alt', path: '/creditsbundles' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Credits Transactions', icon: 'fas fa-exchange-alt', path: '/creditstransactions' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Auto Notifications', icon: 'fas fa-bell', path: '/autonotifications' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'CMS Pages', icon: 'fas fa-file-alt', path: '/cms' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Images', icon: 'fas fa-images', path: '/images' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'City', icon: 'fas fa-crosshairs', path: '/city' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Sports', icon: 'fas fa-futbol', path: '/sports' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Users', icon: 'fas fa-users', path: '/users' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Vaccination Approvals', icon: 'fas fa-id-card', path: '/vaccinations' }"
        >
        </sidebar-item>

        <!-- Phase 1 — Task 3C: list of host applications submitted from the user app -->
        <sidebar-item
          v-if="role == 'Admin'"
          :link="{ name: 'Host Applications', icon: 'fas fa-user-plus', path: '/hostapplications' }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Bookings',
            icon: 'far fa-check-circle',
            path: '/bookings',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Messages',
            icon: 'fas fa-envelope',
            path: '/messages',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'No Show Fee',
            icon: 'fas fa-money-bill-alt',
            path: '/latefee',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Whatsapp Group',
            icon: 'fab fa-whatsapp',
            path: '/whatsappGroup',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Event Schedule',
            icon: 'fa fa-calendar',
            path: '/eventschedule',
          }"
        >
        </sidebar-item>

           <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Support Queries',
            icon: 'fas fa-address-book',
            path: '/support_queries',
          }"
        >
        </sidebar-item>
        
        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Support V2 (Live Chat)',
            icon: 'fas fa-comments',
            path: '/support_v2',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="role == 'Admin'"
          :link="{
            name: 'Event Chat',
            icon: 'fas fa-bullhorn',
            path: '/event_chat',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->
    <sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view :key="$route.fullPath"></router-view>
        </zoom-center-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import SidebarShare from "./SidebarSharePlugin";
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import SidebarFixedToggleButton from "./SidebarFixedToggleButton.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      role: "",
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
  mounted() {
    this.role = window.localStorage.getItem("role");

    this.initScrollbar();
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
